/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { AddCourier } from './AddCourier/AddCourier'
import { AddReadyTime } from './AddReadyTime/AddReadyTime'
import PlatformModule from '../../../../../services/Platform/PlatformModule'


const OptionBar = ({ orderStatus, platformModule, pickupAt }) => {
    if (platformModule !== PlatformModule.UBER_EATS) {
        return null
    }

    return (
      <div
        css={css`
            width: calc(100% - 2em);
            display: flex;
            justify-content: center;
            align-items: flex-start;
            column-gap: 1rem;
        `}
      >
          <AddCourier />
          {['ACCEPTED', 'PREPARING'].includes(orderStatus) && <AddReadyTime pickupAt={pickupAt }/>}
      </div>
    )
}

export { OptionBar }
